export default "__VITE_ASSET__ee1bd39c__"